import React from 'react';
import { MdOutlineLocalShipping } from "react-icons/md";
import { AiOutlineSync } from "react-icons/ai";
import { TiMessages } from "react-icons/ti";
import './FollowSteps.css';

const FollowSteps = () => {
    const ourSupports = [
        {
            class: 'free-shipping',
            icon: MdOutlineLocalShipping,
            title: 'Free Shipping',
            description: 'Sed rutrum ipsum nunc, at ultrices Loream libero consectetur.'
        },
        {
            class: 'money-back',
            icon: AiOutlineSync,
            title: '100% Money Back',
            description: 'Sed rutrum ipsum nunc, at ultrices Loream libero consectetur.'
        },
        {
            class: 'support-time',
            icon: TiMessages,
            title: 'Support 24/7 Days',
            description: 'Sed rutrum ipsum nunc, at ultrices Loream libero consectetur.'
        },

    ]
    return (
        <section className='static lg:absolute left-0 right-0 lg:bottom-[-100px] flex lg:flex-row lg:gap-0 pb-5 flex-col justify-center px-4 lg:px-20 follow-steps-section'>
            {
                ourSupports.map((support, index) =>

                    <div key={index + 1} className={`flex lg:mb-0 mb-6 bg-white ${support.class}`}>
                        <support.icon className='text-7xl mr-7' />
                        <div>
                            <h5 className='text-2xl font-semibold pb-2'>{support.title}</h5>
                            <p className='pr-5'>{support.description}</p>
                        </div>
                    </div>
                )
            }
        </section>
    );
};

export default FollowSteps;